module.exports = __webpack_public_path__ + "fd753d9b6d5d59a6aba98d7e70433c02.svg";